import moment from "moment";
import { AgeType } from "../../Types/PatientCare/PatientBookingType";
import {
  formatLocalDate,
  formatLocalDateTime,
} from "./localDateTime";

export const getFulldate = () => {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export const reportsDateFormate = (date:Date) => {
  const newDate = new Date(date);
  return `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(newDate.getDate()).padStart(2, "0")}`;
};
export const formatDate = (inputDate:Date) => {
  //inputDate convert to MM-dd-yyyy
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const formattedMonth = month.toLowerCase();
  const formattedDate = `${day} ${formattedMonth} ${year}`;
  return formattedDate;
};

export const formatDate2 = (inputDate: Date | string) => {
  return formatLocalDate(inputDate, "DD-MM-YYYY", "");
};
export const DateToyyyy_mm_dd = (inputDate:Date) => {
  // Sep 20, 2023 2:27:01 PM to dd/mm/yy
  const months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const dateObj = new Date(inputDate);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = months[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  return `${year}-${month}-${day}`;
};
export const formatDateTime = (inputDate: Date | string) => {
  return formatLocalDateTime(inputDate, "DD-MM-YYYY hh:mm:ss A", "");
};
export const formatDateToCustomString = (date:Date) => {
  date.setHours(0, 0, 0, 0);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
export const D_M_YFormate = (inputDate:Date) => {
  const parts = new Date(inputDate).toDateString()?.split("-");
  if (parts.length !== 3) {
    return "Invalid date format. Please use yyyy-mm-dd.";
  }
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];
  return `${day}-${month}-${year}`;
};
// export const calculateAge = (dateOfBirth: string) => {
//   const dob = new Date(dateOfBirth);
//   const today = new Date();
//   const yearsDiff = today.getFullYear() - dob.getFullYear();
//   const isBirthdayPassed =
//     today.getMonth() > dob.getMonth() ||
//     (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());

//   return isBirthdayPassed ? yearsDiff : yearsDiff - 1;
// };

export const checkValidDate = (dateString:Date) => {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  // Set the time to midnight (00:00:00)
  inputDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  return (
    inputDate.getTime() > currentDate.getTime()
  );
};

export function getDateInFormat(getDate:Date) {
  const currentDate = new Date(getDate);
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1 and pad with '0' if needed
  const day = String(currentDate?.getDate())?.padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getDateDifference(startDate:string):AgeType {
  const birthDate = new Date(startDate);
  const currentDate = new Date();
  let ageYears = currentDate.getFullYear() - birthDate.getFullYear();
  let ageMonths = currentDate.getMonth() - birthDate.getMonth();
  let ageDays = currentDate.getDate() - birthDate.getDate();
  if (ageDays < 0) {
    ageMonths--;
    ageDays += new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
  }
  if (ageMonths < 0) {
    ageYears--;
    ageMonths += 12;
  }
  return {
    ageDays,
    ageMonths,
    ageYears
  };
}

export const isCurrentOrPreviousDate = (date: Date): boolean => {
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const givenDate = new Date(date);
  givenDate.setHours(0, 0, 0, 0); 

  return givenDate >= currentDate;
};

export function getTimeFormat(inputTime:Date) {
  const timeRegex = /(\d{2}):(\d{2}):(\d{2}) (am|pm)/i;
  const match = new Date(inputTime).toDateString()?.match(timeRegex);

  if (!match) {
    throw new Error("Invalid input time format");
  }

  let [_, hours, minutes, seconds] = match;

  // hours = parseInt(hours, 10);
  // minutes = parseInt(minutes, 10);
  // seconds = parseInt(seconds, 10);

  // if (period?.toLowerCase() === "am" && hours === 12) {
  //   hours = 0;
  // } else if (period?.toLowerCase() === "pm" && hours < 12) {
  //   hours += 12;
  // }

  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  return formattedTime;
}

export const convertToDate = (inputDate:Date) => {
  const dateParts = new Date(inputDate).toDateString()?.split(" ");
  const month = dateParts[0];
  const day = parseInt(dateParts[1]?.replace(",", ""), 10);
  const year = parseInt(dateParts[2], 10);

  const monthMap:any = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };

  return new Date(year, monthMap[month], day);
};

export const getWeekNumber = (date:Date) => {
  const fullDate = new Date(date);
  const dayNumber = fullDate.getDay();
  return dayNumber;
};

export const createDateString = (
  date: string,
  time: string,
  format: "MM-dd-yyyy-T" | "yyyy-mm-dd-t"
) => {
  // convert date and time to Feb 21, 2024 8:12:00 AM this format
  const months = [
    ["Jan", "01"],
    ["Feb", "02"],
    ["Mar", "03"],
    ["Apr", "04"],
    ["May", "05"],
    ["Jun", "06"],
    ["Jul", "07"],
    ["Aug", "08"],
    ["Sep", "09"],
    ["Oct", "10"],
    ["Nov", "11"],
    ["Dec", "12"],
  ];
  const dateParts = date.split("-");
  const timeParts = time.split(":");
  const year = dateParts[0];
  const monthIndex = parseInt(dateParts[1]) - 1;
  const day = dateParts[2];
  const hour = parseInt(timeParts[0]);
  const minute = timeParts[1];
  const isAM = timeParts[2].toUpperCase() === "AM";
  const month = months[monthIndex];
  const formattedHour = isAM
    ? hour === 0
      ? 12
      : hour
    : hour === 12
    ? 12
    : hour + 12;
  switch (format) {
    case "MM-dd-yyyy-T":
      return `${month[0]} ${day}, ${year} ${formattedHour}:${minute}:${timeParts[2]}`;
    case "yyyy-mm-dd-t":
      return `${year}-${month[1]}-${day} ${formattedHour}:${minute}:${timeParts[2]}`;
  }
};

export const fullTo_yyyy_mm_dd = (fullDate:Date) => {
  // const date = new Date(inputDateString);
  const year = fullDate?.getFullYear();
  const month = String(fullDate?.getMonth() + 1)?.padStart(2, "0");
  const day = String(fullDate?.getDate())?.padStart(2, "0");
  return `${year}-${month}-${day}`;
};
export type CalculatedAgeType = {fullAge:{years:number,months:number,days:number},ageType:"D" | "M" | "Y",age:number}
export const calculateAge = (dateString: Date | string):CalculatedAgeType => {
  let birthDate = moment(dateString, "YYYY-MM-DD");
  let today = moment();
  if(moment(dateString,"DD/MM/YYYY",true).isValid()){
    birthDate = moment(dateString, "DD/MM/YYYY");
  }
  let days = today.diff(birthDate, "days");
  let months = today.diff(birthDate, "months");
  let years = today.diff(birthDate, "years");
  let ageType: "D" | "M" | "Y" = "Y";
  let age = years;
  if (years === 0) {
    ageType = "M";
    age = months;
  }
  if (years === 0 && months === 0) {
    ageType = "D";
    age = days;
  }

  return {fullAge:{years,months,days},ageType,age}
};